(function () {
    angular
        .module('website-engagement.dir', ['ngclipboard'])
        .directive('websiteEngagement', ['$rootScope', '$compile', '$templateCache', 'helpers', 'canvasService', 'CANVAS_OPTS', 'plumbService', '$timeout', '$sce', websiteEngagement])

    //Website Engagement Directive
    function websiteEngagement($rootScope, $compile, $templateCache, helpers, canvasService, CANVAS_OPTS, plumbService, $timeout, $sce) {
        return {
            scope: {},
            controller: ['$scope', function ($scope) {
                //var to trigger intercom Script
                var trackIntercom = true;
                // extending translate method, this method not available on isolate scope
                $scope.translate = $rootScope.translate;
                $scope.wasSave = false;

                $scope.breakUrl = () => {
                    return $scope.connections.data.specificUrl.replace(/(.{70})/g, "$1<br />");
                };

                //When we save a the form
                $scope.save = function (notTrackEvent, trackCoach = true) {
                    $scope.isDummyData();

                    //If form data is missing
                    if ($scope.dataFilledCorrectly() === false) {
                        $rootScope.$emit('errorMsg', $scope.translate('canvas.error.601'));
                        $rootScope.$emit('displayEntryEngagementModalError');
                        if($scope.tempConn) {
                            $scope.connections = angular.copy($scope.tempConn);
                        }

                    }
                    //Else we proceed to save and create new elements
                    else {
                        $scope.isDummyData();

                        $scope.trackingTestState = $scope.translate('canvas.entry.websiteEngagement.url.test');
                        $scope.trackingTestClass = '';

                        //Intercom Tracking Event
                        if (trackIntercom && !notTrackEvent) {
                            Intercom('trackEvent', 'AP - Started with website engagement');
                            trackIntercom = false;
                        }

                        //Updates the parent to register its children
                        var parentData = helpers.getConnectionById($scope.connections.parent);
                        if (parentData) {
                            parentData.children = [];
                            parentData.children.push($scope.connections.id);
                            helpers.updateConnections(parentData);
                        }
                        //Save to the global canvas object
                        helpers.updateConnections($scope.connections);
                        //Displays th form data
                        $scope.displayList = false;
                        $rootScope.$emit('hideEntryEngagementModal');
                        //Displays action menu
                        $scope.displaySubMenu = false;
                        //Hides Error
                        $scope.displayError = false;

                        var index = $rootScope.unsavedData.indexOf($scope.connections.id);
                        if (index > -1) {
                            $rootScope.unsavedData.splice(index, 1);
                        }

                        //Save Journey to template
                        canvasService.saveJourneyStorge('journey', JSON.stringify($rootScope.connections), $scope.isElegibleForUpdate);
                        if ($scope.isElegibleForUpdate) {
                            $scope.wasSave = true;
                            $timeout(() => {
                                $scope.wasSave = false;
                            }, 1500);
                        }
                        //Set Back to autoSave
                        $scope.isElegibleForUpdate = true;
                        //Remove Activate Error since its being able to save
                        $scope.displayActivateError = false;
                        $scope.displayErrorBlink = false;
                    }

                    // Listener to show or hide the delete arrow or add connection arrow
                    $rootScope.$on('showDeleteArrow_' + $scope.connections.id, function (event, condition) {
                        $scope.showDeleteArrow = condition;
                    });

                    $rootScope.$on('showConnectionArrow_' + $scope.connections.id, function (event, condition) {
                        $scope.showConnectionArrow = condition;
                    });
                };

                $scope.isDummyData = function() {
                    if($scope.connections.isDummy) {
                        if($scope.connections.data.specificUrl !== 'http://www.yourdomain.com') {
                            delete $scope.connections.isDummy;
                        }
                    }
                };

                //Validates if data is filled correctly or not
                $scope.dataFilledCorrectly = function () {
                    var res = true;

                    if (!$scope.connections.data.source) {
                        $scope.errorInput = true;
                        res = false;
                    }

                    if (($scope.connections.data.source === 'specific-url' || $scope.connections.data.source === 'contains-url') &&
                        ($scope.connections.data.specificUrl === undefined ||
                        $scope.connections.data.specificUrl === '' ||
                        $scope.errorUrl === true ||
                        'http://'.indexOf($scope.connections.data.specificUrl) > -1 ||
                        'https://'.indexOf($scope.connections.data.specificUrl) > -1)
                    ) {
                        $scope.errorUrl = true;
                        res = false;
                    }

                    if(!res) {
                        var index = $rootScope.unsavedData.indexOf($scope.connections.id);
                        if (index === -1) {
                            $rootScope.unsavedData.push($scope.connections.id);
                        }
                    }

                    return res;
                };

                $scope.setLastElem = function (evt) {
                    plumbService.setLastElemClicked($(evt.target).parents('div.shape').attr('id'));
                };

                $scope.menuPos = {
                    left: 440
                };
                $scope.toggleConnectionMenu = function (event) {
                    if($rootScope.connections && $rootScope.connections.length > 1) {
                        $scope.menuPos.left = 200;
                    } else {
                        $scope.menuPos.left = 440;
                    }

                    //Check if form data is filled and a connection exists as only one is allowed
                    if (helpers.checkIfIsConnected(event.target.parentNode.id)) {
                        $rootScope.$emit('errorMsg', $scope.translate('canvas.error.602'));
                    }
                    else {
                        if ($('#' + event.target.parentNode.id).find('.action-conditions').inlineStyle('display') === 'none') {
                            //remove the hidden style
                            $('#' + event.target.parentNode.id).find('.action-conditions').show().prev().show();
                            $scope.displaySubMenu = true;
                            $scope.displayList = false;
                            $rootScope.$emit('hideEntryEngagementModal');
                            $scope.$broadcast('setMenuDefaults');
                        } else {
                            var index = $rootScope.unsavedData.indexOf($scope.connections.id);
                            if (index > -1) {
                                $rootScope.$emit('errorMsg', $scope.translate('canvas.error.611'));
                                $scope.displayList = true;
                                $scope.displaySubMenu = false;
                                $rootScope.$emit('displayEntryEngagementModal', $scope.connections);
                            } else if ($scope.dataFilledCorrectly() === false) {
                                $rootScope.$emit('errorMsg', $scope.translate('canvas.error.603'));
                                $scope.displayList = true;
                                $scope.displaySubMenu = false;
                                $rootScope.$emit('displayEntryEngagementModal', $scope.connections);
                            } else if ($scope.displaySubMenu === false) {
                                $scope.isElegibleForUpdate = false;
                                $scope.save(true, false);
                                $scope.displaySubMenu = true;
                                $scope.displayList = false;
                                $rootScope.$emit('hideEntryEngagementModal');
                                $scope.$broadcast('setMenuDefaults');
                            }
                            else {
                                $scope.displaySubMenu = false;
                                $scope.displayList = false;
                                $rootScope.$emit('hideEntryEngagementModal');
                            }
                        }
                    }
                };

                $scope.config = function (evt) {
                    var newTop = parseInt($(evt.currentTarget).inlineStyle('top')),
                        newLeft = parseInt($(evt.currentTarget).inlineStyle('left'));

                    // check if being dragged and update position
                    if (newTop !== $scope.connections.top || $scope.connections.left !== newLeft) {
                        //update rootScope position
                        helpers.updatePos($scope.connections.id, newTop, newLeft);

                        $scope.connections.top = newTop;
                        $scope.connections.left = newLeft;

                        return false;
                    }
                    //Show form menu
                    if ($scope.displayList === false) {
                        $scope.displayList = true;
                        $rootScope.$emit('displayEntryModal', 'isWebsiteEngagementFormDisplayed', $scope.connections);
                    } else {
                        $scope.trackingTestState = $scope.translate('canvas.entry.websiteEngagement.url.test');
                        $scope.trackingTestClass = '';
                    }
                    //Hide Error
                    $scope.displayError = false;
                    $scope.errorUrl = false;
                    $scope.errorInput = false;
                    $scope.displaySubMenu = false;
                };

                $scope.showTipModal = () => {
                    // displays tip modal
                    $rootScope.$emit('displayEntryEngagementModal', $scope.connections, true);
                };

                $scope.$on('closeConfigMenus', function() {
                    if ($scope.displayList || $scope.displaySubMenu) {
                        $scope.cancel();
                        $scope.displaySubMenu = false;
                        $scope.contMenuConfigs = 0;
                    }
                });

                $scope.cancel = function() { return; };

                $scope.parseDescription = function (desc, specificUrl) {
                    if (specificUrl) {
                        if (desc) {
                            var arrLen = desc.split("");
                            arrLen = arrLen.length;
                            if (arrLen > 15) {
                                return desc.slice(0, 15) + '...';
                            } else {
                                return desc;
                            }
                        } else if ($scope.connections.data.source === 'contains-url') {
                            return $scope.translate('canvas.entry.websiteEngagement.containsUrl');
                        } else {
                            return $scope.translate('canvas.condition.websiteActivity.specificUrl');
                        }
                    } else {
                        if (desc) {
                            desc = desc.splitCharAndUpper();
                        } else {
                            return $scope.translate('commons.enterDetails');
                        }
                    }

                    return desc;
                };

                $scope.deleteEntry = function () {
                    var idx = $rootScope.unsavedData.indexOf($scope.connections.id);
                    if (idx > -1) {
                        $rootScope.unsavedData.splice(idx, 1);
                    }

                    plumbService.deleteElements($scope.connections);
                    $scope.$emit('displayJourney', true);

                    var shapeDelete;
                    shapeDelete = angular.element(document.querySelector('#step-placeholder' + $scope.connections.id));
                    jsPlumb.detachAllConnections(shapeDelete);
                    shapeDelete.remove();

                    $rootScope.deletedEntry = true;
                };

                //Check RootScope connection to check if there is only an Entry on the Canvas.
                //We listen the saveJourneyStorage function on Canvas Service.
                $timeout(function() {
                    $rootScope.$watch('conn', function(){
                        if($scope.connections && $scope.connections.id && document.getElementById($scope.connections.id)) {
                            if ($rootScope.conn && $rootScope.conn.length === 1 && $rootScope.conn[0].type === 'Entry' ) {
                                setTimeout(() => {
                                    plumbService.simpleConnect($scope.connections.id, 'step-placeholder' + $scope.connections.id, 'rgba(207, 207, 218, 1)');
                                }, 100);
                            }else {
                                let arrowConn = angular.element(document.querySelector('#' + $scope.connections.id));
                                jsPlumb.detachAllConnections(arrowConn);
                            }
                        }
                    });
                }, 1000);

                $scope.$watch('connections', (conn) => {
                    if(conn && conn.children && conn.children.length) {
                        $scope.disAllowDrag = helpers.validateDragging(conn);
                    } else if(conn && !conn.children) {
                        $scope.disAllowDrag = true;
                    }
                });
            }],
            link: function (scope, elem, attr) {
                // scope data initialization
                scope.displaySubMenu = false;
                scope.token = $rootScope.getTrackerToken;
                scope.isElegibleForUpdate = true;
                scope.trackingTestState = scope.translate('canvas.entry.websiteEngagement.url.test');
                scope.trackingTestClass = '';

                // load existing
                if ($rootScope.cElement) {
                    // bullet proving multiple targets
                    if (scope.connections) {
                        if (document.getElementById(scope.connections.id)) {
                            delete $rootScope.cElement;
                            return false;
                        }
                    }

                    scope.connections = $rootScope.cElement;
                    delete $rootScope.cElement;

                    //account for legacy change
                    if(scope.connections.data.source === 'anyPage') {
                        scope.connections.data.source = 'any-tracked-page';
                    }

                    if(scope.connections.data.source === 'specificUrl') {
                        scope.connections.data.source = 'specific-url';
                    }

                    // global scope data initialization
                    scope.isElegibleForUpdate = scope.connections.isElegibleForUpdate || false;
                    delete scope.connections.isElegibleForUpdate;

                    if (scope.connections.data.specificUrl) {
                        scope.specificUrl = true;
                        scope.append = true;
                    }

                    //Load Template
                    var template =  angular.element($templateCache.get('entry/website-engagement'));

                    var canvasEl = angular.element(document.querySelector('.canvas'));
                    canvasEl.append(template);

                    scope.$apply(() => {
                        $compile(template)(scope);
                    });

                    $rootScope.$on('activateErr_' + scope.connections.id, function(evt, display) {
                        scope.displayActivateError = display;
                        scope.displayErrorBlink = false;
                    });

                    $rootScope.$on('emptyErr_' + scope.connections.id, function(evt, display) {
                        scope.displayErrorBlink = display;
                        scope.displayActivateError = false;
                    });

                    $rootScope.$on('saveEngagementEntryData' + scope.connections.id, function(evt, conn, err) {
                        scope.tempConn = angular.copy(scope.connections);
                        scope.connections = angular.copy(conn);
                        scope.errorUrl = err;
                        scope.save();
                        scope.connections.wasSave = true;

                        $timeout(function () {
                            scope.connections.wasSave = false;
                        }, 2000);
                    });

                    if(scope.connections && scope.connections.children && scope.connections.children.length) {
                        $timeout(() => {
                            scope.disAllowDrag = helpers.validateDragging(scope.connections);
                        }, 1000)
                    } else if(scope.connections && !scope.connections.children) {
                        scope.disAllowDrag = true;
                    }

                    scope.save(true, false);
                    scope.connections.wasSave = false;

                    $timeout(() => {
                        if ($rootScope.conn && $rootScope.conn.length === 1 && $rootScope.conn[0].type === 'Entry' ) {
                            setTimeout(() => {
                                plumbService.simpleConnect(scope.connections.id, 'step-placeholder' + scope.connections.id, 'rgba(207, 207, 218, 1)');
                            }, 100);
                        }
                    }, 200);
                    $rootScope.$emit('closeMenus', true);
                    plumbService.setInitDragConnect(scope.connections);
                }

                scope.deleteArrow = function() {
                    if(scope.connections.hasOwnProperty('children')) {
                        scope.hasArrow = false;
                        plumbService.deleteArrows(scope.connections);
                    }
                };
            }
        };
    }

}());



// WEBPACK FOOTER //
// ./app/directives/canvas_directives/website-engagement.js